import { FC } from "react";
import { Icon, Stack, Text } from "@chakra-ui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

import { IScheduleItem } from "../../../../../api/schedule/types.ts";
import { isStringWithNumber, formatPriceWithoutZeros } from "../../../../../utils";

interface Props {
  payment: IScheduleItem;
  showDetails: boolean;
}

export const ScheduleItemAmountWithArrow: FC<Props> = ({ payment, showDetails }) => {
  const rawTotal = payment.status === "PAID" ? payment.paid : payment.total;
  const total = isStringWithNumber(rawTotal) ? formatPriceWithoutZeros(Number(rawTotal)) : "";

  const textVariant = payment.status === "OVERDUE" ? "red" : "brand";

  return (
    <Stack pt="2px" alignItems="flex-end" spacing="6px">
      <Text mr="4px" variant={textVariant} fontSize="12px" fontFamily="Normalidad Medium Var">
        {total}
      </Text>

      <Icon
        as={ChevronDownIcon}
        mr="-3px"
        boxSize="18px"
        color="gray.600"
        strokeWidth="2.5px"
        transform={showDetails ? "rotate(180deg)" : "rotate(0deg)"}
        transition="transform 0.3s ease-in-out"
      />
    </Stack>
  );
};
